import axiosInstance from "../../api/axiosInstance";

export const fetchTournamentsByQueryAPI = async (query) => {
  const tournamentsList = await axiosInstance.get(
    `tournaments/search-for-tournament?query=${query}`
  );

  return tournamentsList.data;
};
